export function resetFilterForm() {
    $(".filter-form .clear").on("click", function () {
        document.querySelector('.filter-form').reset();
        window.location.href = window.location.href.split("?")[0];
        return false;
    });
    $('#location, #date, #distance ').change(function () {
        this.form.submit();
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/resetFilterForm.js